import { defineMessages } from 'react-intl';
import type { TechnologyExpertiseEnum } from '@foundershub/api-client';

export const technologyExpertiseLabels = defineMessages<TechnologyExpertiseEnum>({
  iaas: {
    defaultMessage: 'IaaS',
    description: 'technology expertise category label',
  },
  paas: {
    defaultMessage: 'PaaS',
    description: 'technology expertise category label',
  },
  saas: {
    defaultMessage: 'SaaS',
    description: 'technology expertise category label',
  },
  'ai-machine-learning': {
    defaultMessage: 'AI + Machine Learning',
    description: 'technology expertise category label',
  },
  'data-analytics': {
    defaultMessage: 'Data Analytics',
    description: 'technology expertise category label',
  },
  'cloud-architecture': {
    defaultMessage: 'Cloud Architecture',
    description: 'technology expertise category label',
  },
  'cloud-migration': {
    defaultMessage: 'Cloud Migration',
    description: 'technology expertise category label',
  },
  compute: {
    defaultMessage: 'Compute',
    description: 'technology expertise category label',
  },
  containers: {
    defaultMessage: 'Containers',
    description: 'technology expertise category label',
  },
  databases: {
    defaultMessage: 'Databases',
    description: 'technology expertise category label',
  },
  'developer-tools': {
    defaultMessage: 'Developer Tools',
    description: 'technology expertise category label',
  },
  devops: {
    defaultMessage: 'DevOps',
    description: 'technology expertise category label',
  },
  'game-development': {
    defaultMessage: 'Game Development',
    description: 'technology expertise category label',
  },
  'high-performance-computing-hpc': {
    defaultMessage: 'High Performance Computing (HPC)',
    description: 'technology expertise category label',
  },
  'hybrid-multicloud': {
    defaultMessage: 'Hybrid + multicloud',
    description: 'technology expertise category label',
  },
  'identity-security': {
    defaultMessage: 'Identity & Security',
    description: 'technology expertise category label',
  },
  'internet-of-things': {
    defaultMessage: 'Internet of Things',
    description: 'technology expertise category label',
  },
  'management-governance': {
    defaultMessage: 'Management & Governance',
    description: 'technology expertise category label',
  },
  media: {
    defaultMessage: 'Media',
    description: 'technology expertise category label',
  },
  'mixed-reality': {
    defaultMessage: 'Mixed Reality',
    description: 'technology expertise category label',
  },
  'mobile-development': {
    defaultMessage: 'Mobile Development',
    description: 'technology expertise category label',
  },
  networking: {
    defaultMessage: 'Networking',
    description: 'technology expertise category label',
  },
  'open-source-software': {
    defaultMessage: 'Open Source Software',
    description: 'technology expertise category label',
  },
  outsourcing: {
    defaultMessage: 'Outsourcing',
    description: 'technology expertise category label',
  },
  storage: {
    defaultMessage: 'Storage',
    description: 'technology expertise category label',
  },
  'web-development': {
    defaultMessage: 'Web Development',
    description: 'technology expertise category label',
  },
  'html-css': {
    defaultMessage: 'HTML & CSS',
    description: '{Locked="HTML"}, {Locked="CSS"}, names of programming languages',
  },
  python: {
    defaultMessage: 'Python',
    description: '{Locked="Python"}, name of programming language',
  },
  javascript: {
    defaultMessage: 'JavaScript',
    description: '{Locked="JavaScript"}, name of programming language',
  },
  java: {
    defaultMessage: 'Java',
    description: '{Locked="Java"}, name of programming language',
  },
  sql: {
    defaultMessage: 'SQL',
    description: '{Locked="SQL"}, name of programming language',
  },
  bashshell: {
    defaultMessage: 'Bash/Shell',
    description: '{Locked="Bash"}, name of scripting language',
  },
  ruby: {
    defaultMessage: 'Ruby',
    description: '{Locked="Ruby"}, name of programming language',
  },
  c: {
    defaultMessage: 'C++',
    description: '{Locked="C++"}, name of programming language',
  },
  r: {
    defaultMessage: 'R',
    description: '{Locked="R"}, name of programming language',
  },
  'c-1': {
    defaultMessage: 'C#',
    description: '{Locked="C#"}, name of programming language',
  },
  php: {
    defaultMessage: 'PHP',
    description: '{Locked="PHP"}, name of programming language',
  },
  go: {
    defaultMessage: 'Go',
    description: '{Locked="Go"}, name of programming language',
  },
  'c-2': {
    defaultMessage: 'C',
    description: '{Locked="C"}, name of programming language',
  },
});
